import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import styled from "styled-components";
import { ApplicationStore } from "src/store";
import { IsCountryCanada } from "src/store/selectors/account";
import { getInterestRate, getSelectedPaymentType } from "src/store/selectors/vehicles";
import { formatNumberAsPercentage } from "src/utils";
import { getDealerOfferInterestRateByVin, hasDealerOfferByVin } from "src/store/selectors/dealerOffer";

interface Props {
    vin: string;
    offerIndex?: number;
}

const APR = ({ apr, isCanada, paymentType, t }: Props & ReturnType<typeof mapStateToProps> & WithTranslation) => {
    if (!isCanada || paymentType === "cash") {
        return null;
    }

    return (
        <Container>
            <Rate>{formatNumberAsPercentage(apr)}</Rate>
            <Copy>{t("APR")}</Copy>
        </Container>
    );
};

const Container = styled.div.attrs(() => ({
    className: "APR__container",
}))`
    font-weight: bold;
`;

const Rate = styled.span.attrs(() => ({
    className: "APR__rate",
}))`
    font-size: 30px;
    margin-right: 8px;
`;

const Copy = styled.span.attrs(() => ({
    className: "APR__copy",
}))`
    font-size: 20px;
    text-transform: uppercase;
`;

const mapStateToProps = (state: ApplicationStore, { vin, offerIndex }: Props) => {
    return {
        apr: hasDealerOfferByVin(state, vin)
            ? getDealerOfferInterestRateByVin(state, vin)
            : getInterestRate(state, vin, offerIndex),
        isCanada: IsCountryCanada(state),
        paymentType: getSelectedPaymentType(state, vin) as string,
    };
};

export default connect(mapStateToProps)(withTranslation()(APR));
